import type { Program } from 'models';
import { ProgramAdmins } from './program-admins';
import { ProgramAuthor } from './program-author';
import { ProgramEnroll } from './program-enroll';
import { ProgramExpectedOutcomes } from './program-expected-outcomes';
import { ProgramFeaturedParticipants } from './program-featured-participants';
import { ProgramInstructors } from './program-instructors';
import { ProgramSponsors } from './program-sponsors';
import { ProgramTopics } from './program-topics';

type P = {
  program: Program;
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const ProgramAboutDetails = ({ program }: P) => (
  <>
    {program.authorName ? (
      <div className="description-card">
        <ProgramAuthor program={program} />
      </div>
    ) : null}
    {program.sponsors?.length ? (
      <div className="description-card description-card--sponsors">
        <ProgramSponsors sponsors={program.sponsors} />
      </div>
    ) : null}
    {program.administrators ? (
      <div className="description-card description-card--administrators">
        <ProgramAdmins administrators={program.administrators} />
      </div>
    ) : null}
    {program.whoShouldEnroll ? (
      <div className="description-card description-card--enroll">
        <ProgramEnroll whoShouldEnroll={program.whoShouldEnroll} />
      </div>
    ) : null}
    {program.expectedOutcomes?.length ? (
      <div className="description-card description-card--outcomes">
        <ProgramExpectedOutcomes expectedOutcomes={program.expectedOutcomes} />
      </div>
    ) : null}
    {program.topics.length > 0 ? (
      <div className="description-card description-card--topics">
        <ProgramTopics topics={program.topics} />
      </div>
    ) : null}
    {program.instructors?.length ? (
      <div className="description-card description-card--instructors">
        <ProgramInstructors instructors={program.instructors} />
      </div>
    ) : null}
    {program.featuredParticipants?.length ? (
      <div className="description-card">
        <ProgramFeaturedParticipants participants={program.featuredParticipants} />
      </div>
    ) : null}
  </>
);

export default ProgramAboutDetails;
